module.exports = __webpack_public_path__ + "static/media/star.8a813fec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/star.svg
// module id = 282
// module chunks = 0